/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RuleHistoryDialog.vue?vue&type=template&id=76a207bc"
import script from "./RuleHistoryDialog.vue?vue&type=script&lang=js"
export * from "./RuleHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports